/**
 * Canonical platform primary-action paint.
 * Distinct from brand accent (`palette.primary.main` / `#E8750C`).
 * Not tenant-aware. Opt-in tenant CTAs use `tenantActionCtaSx`.
 */

import type { Theme } from "@mui/material/styles";

export const primaryActionSx = {
  bgcolor: (theme: Theme) => theme.customTokens.cta.fill,
  color: (theme: Theme) => theme.customTokens.cta.text,
  border: "none",
  "&:hover": {
    bgcolor: (theme: Theme) => theme.customTokens.cta.fillHover,
  },
  "&:active": {
    bgcolor: (theme: Theme) => theme.customTokens.cta.fillActive,
  },
  "&.Mui-disabled": {
    bgcolor: (theme: Theme) => theme.palette.action.disabledBackground,
    color: (theme: Theme) => theme.palette.action.disabled,
    boxShadow: "none",
  },
  "&:focus-visible": {
    outline: (theme: Theme) => `2px solid ${theme.palette.custom.selection.ring}`,
    outlineOffset: 2,
  },
} as const;
